// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"1bea55f2","388":"9da0f0d9","418":"2e74c42f"}[chunkId] + ".chunk.js";
};